import React from 'react'
import {LocalesMercadoItem} from './LocalesMercadoItem'

function LocalesMercado(props) {
  const displayItems = (props) => {
    if (props) {
      const localesMercado = props.localesMercado

      if (localesMercado) {
        if (localesMercado.length > 0) {
          return localesMercado.map((localMercado, index) => {
            return (
              <LocalesMercadoItem
                key={index}
                localMercado={localMercado}
                editLocal={props.editLocal}
              />
            )
          })
        } else {
          return <h3>No hay locales</h3>
        }
      } else {
        return null
      }
    } else {
      return null
    }
  }

  return <>{displayItems(props)}</>
}

export {LocalesMercado}
